import React, { useContext } from 'react';
import { BreadcrumbsContext } from "../../context/BreadcrumbContext"
import { Breadcrumb } from 'antd';

const Breadcrumbs: React.FC = () => {
  const context = useContext(BreadcrumbsContext)

  if (!context) {
    throw new Error('Breadcrumbs must be used within a BreadcrumbsProvider')
  }

  const { breadcrumbs } = context;
    return (
        <Breadcrumb
        items={breadcrumbs}
        />
    );
};

export default Breadcrumbs;